module.exports = __webpack_public_path__ + "Gotham-Medium.c4aa7f4be8d9578c74eb.woff";


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/assets/fonts/Gotham-Medium.woff
// module id = ../../../../../src/assets/fonts/Gotham-Medium.woff
// module chunks = 2